import React from 'react';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <h1> Welcome</h1>
      <p>Data Engineer & Fullstack Developer</p>
    </section>
  );
};

export default Hero;